import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const get = (obj, path) => path.split(".").reduce((o, k) => (o ? o[k] : undefined), obj);

export const set = (obj, path, value) => {
  const keys = path.split(".");
  const out = { ...obj };
  let cur = out;
  keys.slice(0, -1).forEach((k) => { cur[k] = { ...(cur[k] || {}) }; cur = cur[k]; });
  cur[keys[keys.length - 1]] = value;
  return out;
};

export function FieldGrid({ fields, values, onChange, prefix }) {
  return (
    <div className="grid sm:grid-cols-2 gap-5">
      {fields.map((f) => (
        <div key={f.k} className={f.wide ? "sm:col-span-2" : ""}>
          <Label className="text-sm mb-2 block text-slate-300">{f.label}</Label>
          <Input data-testid={`${prefix}-${f.k.replace(/\./g, "-")}`} value={get(values, f.k) || ""} placeholder={f.ph}
            type={f.type || "text"} onChange={(e) => onChange(set(values, f.k, e.target.value))}
            className="bg-slate-950 border-slate-700 text-slate-100" />
          {f.hint && <p className="text-xs text-slate-500 mt-1.5">{f.hint}</p>}
        </div>
      ))}
    </div>
  );
}
